export const EXCHANGE_LABELS: Record<string, string> = {
  US: "US",
  X: "Currency Rates",
  CBT: "Chicago Board of Trade (CBOT)",
  CME: "Chicago Mercantile Exchange (CME)",
  NYB: "ICE Futures US",
  CMX: "New York Commodities Exchange (COMEX)",
  NYM: "New York Mercantile Exchange (NYMEX)",
  BA: "Buenos Aires Stock Exchange (BYMA)",
  VI: "Vienna Stock Exchange",
  AX: "Australian Stock Exchange (ASX)",
  XA: "Cboe Australia",
  BR: "Euronext Brussels",
  SA: "Sao Paulo Stock Exchange (BOVESPA)",
  CN: "Canadian Securities Exchange",
  NE: "Cboe Canada",
  TO: "Toronto Stock Exchange (TSX)",
  V: "TSX Venture Exchange (TSXV)",
  SN: "Santiago Stock Exchange",
  SS: "Shanghai Stock Exchange",
  SZ: "Shenzhen Stock Exchange",
  CL: "Colombia Stock Exchange",
  PR: "Prague Stock Exchange Index",
  CO: "Nasdaq OMX Copenhagen",
  CA: "Egyptian Exchange Index (EGID)",
  TL: "Nasdaq OMX Tallinn",
  XD: "Cboe Europe",
  NX: "Euronext",
  HE: "Nasdaq OMX Helsinki",
  PA: "Euronext Paris",
  BE: "Berlin Stock Exchange",
  BM: "Bremen Stock Exchange",
  DU: "Dusseldorf Stock Exchange",
  F: "Frankfurt Stock Exchange",
  HM: "Hamburg Stock Exchange",
  HA: "Hanover Stock Exchange",
  MU: "Munich Stock Exchange",
  SG: "Stuttgart Stock Exchange",
  DE: "Deutsche Boerse XETRA",
  REGA: "Collectable Indices",
  AT: "Athens Stock Exchange (ATHEX)",
  HK: "Hong Kong Stock Exchange (HKEX)",
  BD: "Budapest Stock Exchange",
  IC: "Nasdaq OMX Iceland",
  BO: "Bombay Stock Exchange",
  NS: "National Stock Exchange of India",
  JK: "Indonesia Stock Exchange (IDX)",
  IR: "Euronext Dublin",
  TA: "Tel Aviv Stock Exchange",
  TI: "EuroTLX",
  MI: "Italian Stock Exchange",
  T: "Tokyo Stock Exchange",
  KW: "Boursa Kuwait",
  RG: "Nasdaq OMX Riga",
  VS: "Nasdaq OMX Vilnius",
  KL: "Malaysian Stock Exchange",
  MX: "Mexico Stock Exchange (BMV)",
  AS: "Euronext Amsterdam",
  NZ: "New Zealand Stock Exchange (NZX)",
  OL: "Oslo Stock Exchange",
  PS: "Philippine Stock Exchange Indices",
  WA: "Warsaw Stock Exchange",
  LS: "Euronext Lisbon",
  QA: "Qatar Stock Exchange",
  RO: "Bucharest Stock Exchange",
  SI: "Singapore Stock Exchange (SGX)",
  JO: "Johannesburg Stock Exchange",
  KS: "Korea Stock Exchange",
  KQ: "KOSDAQ",
  MC: "Madrid Stock Exchange (BME)",
  SR: "Tadawul Secondary",
  SAU: "Saudi Exchange (Tadawul)",
  ST: "Nasdaq OMX Stockholm",
  SW: "Swiss Exchange (SIX)",
  TWO: "Taiwan OTC Exchange",
  TW: "Taiwan Stock Exchange (TWSE)",
  BK: "Stock Exchange of Thailand (SET)",
  IS: "Borsa Istanbul",
  AE: "Dubai Financial Market",
  AQ: "Aquis Exchange AQSE",
  XC: "Cboe UK",
  L: "London Stock Exchange",
  IL: "London Stock Exchange (IOB)",
  CR: "Caracas Stock Exchange",
  VN: "Ho Chi Minh City Stock Exchange",
};

export const getExchangeLabel = (exchange?: string | null): string => {
  if (!exchange) return "";
  const normalized = exchange.startsWith(".") ? exchange.slice(1) : exchange;
  return EXCHANGE_LABELS[normalized] ?? exchange;
};
